import React, { FC } from 'react';
import { useIntl } from 'react-intl';

import { useRouter } from '@/hooks/useRouter';

import ReferralCTAColumn from './ReferralCTAColumn';

interface IBlockElement {
  type: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  value: any;
}

interface IReferralCTA {
  left: IBlockElement[];
  right: IBlockElement[];
  isAuth?: boolean;
  isTravelCredit?: boolean;
  className?: string;
  updateRedirectPath?: (path: string) => void;
}

const ReferralCTA: FC<IReferralCTA> = ({
  left,
  right,
  isAuth = false,
  isTravelCredit = false,
  className,
  updateRedirectPath,
}) => {
  const intl = useIntl();
  const btnTextRenter = intl.formatMessage({
    defaultMessage: 'Refer a host',
    id: 'ceae+7',
  });
  const btnTextOwner = intl.formatMessage({
    defaultMessage: 'Invite a guest',
    id: 'YlphMe',
  });

  const route = useRouter();

  const shareFor = route.pathname?.split('/').pop() || '';
  let btnText = '';

  if (isAuth) {
    btnText = shareFor === 'owner' ? btnTextOwner : btnTextRenter;
  }

  const isOneCol = isAuth && !isTravelCredit;

  const gapSpace = isOneCol ? 6 : 16;
  const position = isOneCol ? 'center' : 'start';

  return (
    <section
      className={`grid grid-cols-1 mb-20 gap-${gapSpace} md:gap-16 items-${position} md:grid-cols-2 ${className}`}>
      <ReferralCTAColumn
        blocks={left}
        isAuth={isAuth}
        btnText={btnText ? btnText : btnTextOwner}
        shareFor={isTravelCredit ? 'owner' : shareFor}
        isTravelCredit={isTravelCredit}
        updateRedirectPath={updateRedirectPath}
        path="renter"
      />
      <ReferralCTAColumn
        blocks={right}
        isAuth={isAuth}
        btnText={btnText ? btnText : btnTextRenter}
        shareFor={isTravelCredit ? 'renter' : shareFor}
        isTravelCredit={isTravelCredit}
        updateRedirectPath={updateRedirectPath}
        path="owner"
      />
    </section>
  );
};

export default ReferralCTA;
